module.exports = __webpack_public_path__ + "media/educator_advisory_board/Wendy_Stouffer-d99e40d6.png";